const axios = require("axios");
const { getBaseUrl } = require("./baseUrl");
/* NodeJS */
module.exports = {
  getProperty: (propertyUid) =>
    getBaseUrl().then((url) =>
      axios({
        method: "POST",
        url: `${url}/access-token?property_uid=${propertyUid}`,
      })
    ),
};